import Collapse from "@mui/material/Collapse";
import { check } from "../../../utility-functions/assetLoader";


const TrialCard = ({ value, name, title, subtitle, selected, onChange, children }) => {
  return (
    <label
      className={`trial-card ${selected ? "selected" : ""}`}
      style={{ display: "flex", flexDirection: "column" }}
    >
      <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
        <div className="trial-content">
          <div className="trial-title">{title}</div>
          <div className="trial-subtitle">{subtitle}</div>
        </div>
        <input
          type="radio"
          name={name}
          value={value}
          checked={selected}
          onChange={onChange}
        />
        <span className="radio-ui" aria-hidden="true">
          {selected && check()}
        </span>
      </div>

      <Collapse in={selected} timeout={300}>
        <div className="trial-divider" />
        {children}
      </Collapse>
    </label>
  );
};

export default TrialCard;
